@use "styles/variables" as *;

.ignoreItemsWrap {
  background: rgba(255, 56, 39, 0.1);
  border-radius: 4px;
  padding: 8px;
  margin-bottom: 20px;

  .messageWrap {
    display: flex;
    justify-content: space-between;
    padding: 5px;
    cursor: pointer;
    .message {
      font-weight: 500;
      font-size: 14px;
      color: #ff3827;
      margin: 0;
    }

    .arrow {
      width: 30px;
      text-align: center;

      & svg {
        color: #ff3827;
        width: 12px;
      }

      &.rotate svg {
        transform: rotate(180deg);
      }
    }
  }

  .tablesWrap {
    display: none;

    &.visible {
      display: block;
    }

    .ignoreItemsTable {
      width: 100%;
      background: #f9f8fb;
      border-radius: 6px;
      display: flex;
      flex-direction: column;
      margin: 10px auto 0;

      .titles {
        display: flex;
        border-bottom: 1px solid $borderColor;
        justify-content: space-between;

        .titleItem {
          font-size: 12px;
          font-weight: 500;
          width: 20%;
          padding: 10px;
          min-width: 60px;
          @media (max-width: 500px) {
            padding: 5px;
          }
          &:first-child {
            width: 5%;
            @media (max-width: 500px) {
              min-width: 50px;
            }
          }
          &:nth-child(5) {
            @media (max-width: 500px) {
              width: 5%;
              min-width: 50px;
            }
          }
          &:last-child {
            border-right: none;
            @media (max-width: 500px) {
              width: 5%;
              min-width: 50px;
            }
          }
        }
      }

      .tableRow {
        display: flex;
        justify-content: space-between;
        align-items: center;

        &:last-child {
          border-bottom: none;
        }

        .tableCell {
          font-size: 12px;
          font-weight: 400;
          padding: 10px;
          width: 20%;
          min-width: 60px;
          @media (max-width: 500px) {
            padding: 5px;
          }
          &:first-child {
            width: 5%;
            @media (max-width: 500px) {
              min-width: 50px;
            }
          }
          &:nth-child(5) {
            @media (max-width: 500px) {
              width: 5%;
              min-width: 50px;
            }
          }
          &:last-child {
            border-right: none;
            @media (max-width: 500px) {
              width: 5%;
              min-width: 50px;
            }
          }
        }
      }
    }
  }
}
